import React from 'react'
import { HashRouter, Switch, Route } from 'react-router-dom'
import './App.less'
import Home from '@pages/Home'
import StoresMap from '@pages/StoresMap'

const style = process.env.NODE_ENV === 'development' ? 'pa-3' : ''

const App = () => {
  if (process.env.NODE_ENV === 'development') {
    return (
      <div className="App">
        <div className={`App-container  ${style}`}>
        <HashRouter>
          <Switch>
            <Route path="/shopping">
              <StoresMap title="實體購物門市據點" subtitle="ChaCha STORE LOCATIONS SEARCH" />
            </Route>
            <Route path="/delivery">
              <StoresMap title="特約門市取貨據點" subtitle="ChaCha PICK UP STORE LOCATIONS" onlyDelivery />
            </Route>
            <Route path="/">
              <Home />
            </Route>
          </Switch>
          </HashRouter>
        </div>
      </div>
    )
  }
  // process.env.NODE_ENV === 'production'
  if (process.env.REACT_APP_MAP_TYPE === 'shopping') {
    return (
      <div className="App">
        <div className={`App-container  ${style}`}>
          <StoresMap title="實體購物門市據點" subtitle="ChaCha STORE LOCATIONS SEARCH" />
        </div>
      </div>
    )
  } else if (process.env.REACT_APP_MAP_TYPE === 'delivery') {
    return (
      <div className="App">
        <div className={`App-container  ${style}`}>
          <StoresMap title="特約門市取貨據點" subtitle="ChaCha PICK UP STORE LOCATIONS" onlyDelivery />
        </div>
      </div>
    )
  }

  return null
}

export default App;
